import {
  Button,
  CloseButton,
  Dialog,
  Portal,
  Spinner,
  Textarea,
} from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import { useRating } from "../hooks/useRatings";
import StarRating from "./StarRating";
import { toaster } from "./ui/toaster";

const RatingModal = (): JSX.Element => {
  const [score, setScore] = useState<number>(0);
  const [comment, setComment] = useState<string>("");
  const [open, setOpen] = useState(false);

  const isButtonDisabled = useMemo(() => {
    return score === 0;
  }, [score]);

  const { createRating, isRatingCreationLoading, shouldShowRatingModal } =
    useRating({
      onSuccess: () => {
        toaster.create({
          title: "¡Gracias por tu feedback!",
          description: "Tu calificación ha sido registrada exitosamente.",
          type: "success",
        });
      },
      onError: () => {
        toaster.create({
          title: "Error",
          description: "Hubo un error al registrar tu calificación.",
          type: "error",
        });
      },
    });

  useEffect(() => {
    setOpen(shouldShowRatingModal !== undefined && shouldShowRatingModal);
  }, [shouldShowRatingModal]);

  const onClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    await createRating({ score, comment: comment.trim() || undefined });
    setOpen(false);
  };

  return (
    <Dialog.Root open={open} onOpenChange={(e) => setOpen(e.open)}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content maxW="500px">
            <Dialog.Header borderBottom="1px solid #ebecef80" padding="4">
              <Dialog.Title fontSize={"md"}>
                ¿Qué tanto recomendarías Palomma a otra inmobiliaria?
              </Dialog.Title>
            </Dialog.Header>
            <Dialog.CloseTrigger asChild>
              <CloseButton marginRight="2" onClick={onClose} />
            </Dialog.CloseTrigger>

            <Dialog.Body py={6} px={6}>
              {isRatingCreationLoading ? (
                <Spinner />
              ) : (
                <>
                  <StarRating
                    value={score / 2}
                    onChange={(value) => setScore(value * 2)}
                    size={40}
                  />

                  {!!score && (
                    <Textarea
                      placeholder="Comentarios (opcional)"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      resize="none"
                      rows={3}
                      mt={4}
                    />
                  )}

                  <Button
                    disabled={isButtonDisabled}
                    onClick={handleSubmit}
                    width="100%"
                    mt={4}
                  >
                    Enviar
                  </Button>
                </>
              )}
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
export default RatingModal;
